export const mutations = {
    setSecaoProduto(state, secao){
        state.secaoProduto = secao
    },
    setSecoesProduto(state, secoes){
        state.secoesProduto = secoes
    },
    setModalCadastroSecaoProduto(state, status){
        state.modalCadastroSecaoProduto = status
    },
    setModalExcluirSecaoProduto(state, status){
        state.modalExcluirSecaoProduto = status
    }
}

export default {}